import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import { initialMostLikelyMorphologicCodesModalState, IContentMostLikelyMorphologicCodesGrid } from '@/modules/configurationModule/detail/samples/mostLikelyDiagnoses/MostLikelyMorphologicCodes.models'

@Component
export default class MostLikelyMorphologicCodesModal extends Vue {
    @Ref() readonly mostLikelyMorphologicCodesModal!: any
    @Prop(String) readonly actionTitle!: string
    @Emit()
    update(mostLikelyMorphologicCodes: IContentMostLikelyMorphologicCodesGrid[]): IContentMostLikelyMorphologicCodesGrid[] {
        return mostLikelyMorphologicCodes
    }
    @Emit()
    create(mostLikelyMorphologicCodes: IContentMostLikelyMorphologicCodesGrid) {
        return mostLikelyMorphologicCodes
    }

    private state: IContentMostLikelyMorphologicCodesGrid
    constructor() {
        super()
        this.state = initialMostLikelyMorphologicCodesModalState()
    }

    get canUpdateOrCreate(): boolean {
        return Object.keys(this.fields).some((key: any) => {
            return this.fields?.[key]?.dirty
        })
    }

    get modelValidated(): boolean {
        const modelValidated = !!this.state.code && !!this.state.description
        const hasErrors = !!this.errors.count()
        return this.canUpdateOrCreate && !hasErrors && modelValidated
    }

    async show(selectedRow: IContentMostLikelyMorphologicCodesGrid): Promise<void> {
        this.state = initialMostLikelyMorphologicCodesModalState()
        await this.$validator.reset()
        if (selectedRow) {
            this.state = { ...selectedRow }
        }
        this.mostLikelyMorphologicCodesModal.show()
    }

    hide() { this.mostLikelyMorphologicCodesModal.hide() }

    actionModal() {
        if (this.state?.id) {
            this.update([this.state])
        } else {
            this.create(this.state)
        }
    }
}
